import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardComponent, CardHeaderComponent, CardStatusComponent} from '@shared/module/card/component';
import {TranslateModule} from '@ngx-translate/core';
import {SerenityFormsModule} from '@form';
import {ReactiveFormsModule} from '@angular/forms';
import { CardNoDataComponent } from './component/card-no-data/card-no-data.component';


@NgModule({
  declarations: [
    CardComponent,
    CardHeaderComponent,
    CardStatusComponent,
    CardNoDataComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SerenityFormsModule,
    ReactiveFormsModule
  ],
  exports: [
    CardComponent,
    CardHeaderComponent,
    CardStatusComponent,
    CardNoDataComponent
  ]
})
export class CardModule {
}
